import { computed } from "vue";

export function useCardIcons(
  cardData: any,
  essentialsContent: any,
  allAccessContent: any,
  freeContent: any,
  routeName: string
) {
  const iconType = (type: string): string | null => {
    if (isOneOfSpecificType(type)) {
      return null;
    }
    return type;
  };

  const iconComponent = (type: string): string | null => {
    switch (type) {
      case "spiked-circle":
        return "cu-icon-spiked-circle";
      case "curved-rectangle":
        return "cu-icon-curved-rectangle";
      case "color-stars":
        return "cu-icon-color-stars";
      default:
        return null;
    }
  };

  const isOneOfSpecificType = (type: string): boolean => {
    return ["spiked-circle", "curved-rectangle", "color-stars"].includes(type);
  };

  const essentialsAllaccessIconGarden = computed(() => {
    const labels = [];
    if (essentialsContent.value) labels.push("Essentials");
    if (allAccessContent.value) labels.push("All Access");
    const text = labels.join(", ");
    return text
      ? {
          type: "cart-thick",
          text,
        }
      : null;
  });

  const filteredGarden = computed(() => {
    const gardens = cardData.value?.cardGarden ?? [];
    if (
      essentialsAllaccessIconGarden.value &&
      !freeContent.value &&
      routeName !== "content-bundle"
    ) {
      gardens.push(essentialsAllaccessIconGarden.value);
    }
    return gardens?.filter((g: any) => g.type !== "globe") ?? [];
  });

  return {
    iconType,
    iconComponent,
    isOneOfSpecificType,
    essentialsAllaccessIconGarden,
    filteredGarden,
  };
}
